export default "__VITE_ASSET__BCIVM5aN__"